import {
  VENDOR_TAGS_FETCH_BEGIN,
  VENDOR_TAGS_FETCH_SUCCESS,
  VENDOR_TAGS_FETCH_FAILURE,
  TAGS_CREATE_BEGIN,
  TAGS_CREATE_SUCCESS,
  TAGS_CREATE_FAILURE,
  TAGS_DELETE_BEGIN,
  TAGS_DELETE_SUCCESS,
  TAGS_DELETE_FAILURE,
  VENDOR_TAG_UPDATE_BEGIN,
  VENDOR_TAG_UPDATE_SUCCESS,
  VENDOR_TAG_UPDATE_FAILURE
} from '../actions/tagsActions';

const initialState = {
  items: [],
  loading: false,
  error: null,
  status: {
    fetch: 'idle',
    create: 'idle',
    update: 'idle',
    delete: 'idle'
  },
  total: 0,
  page: 1,
  perPage: 10
};

export default function tagsReducer(state = initialState, action) {
  switch (action.type) {
    case VENDOR_TAGS_FETCH_BEGIN:
      return { ...state, loading: true, error: null, status: { ...state.status, fetch: 'loading' } };
    case TAGS_CREATE_BEGIN:
      return { ...state, loading: true, error: null, status: { ...state.status, create: 'loading' } };
    case TAGS_DELETE_BEGIN:
      return { ...state, loading: true, error: null, status: { ...state.status, delete: 'loading' } };
    case VENDOR_TAG_UPDATE_BEGIN:
      return { ...state, loading: true, error: null, status: { ...state.status, update: 'loading' } };
    case VENDOR_TAGS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items,
        total: action.payload.total,
        page: action.payload.page,
        perPage: action.payload.perPage,
        status: { ...state.status, fetch: 'succeeded' }
      };
    case TAGS_CREATE_SUCCESS:
      return { ...state, loading: false, status: { ...state.status, create: 'succeeded' } };
    case TAGS_DELETE_SUCCESS:
      return { ...state, loading: false, status: { ...state.status, delete: 'succeeded' } };
    case VENDOR_TAG_UPDATE_SUCCESS:
      return { ...state, loading: false, status: { ...state.status, update: 'succeeded' } };
    case VENDOR_TAGS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload.error, status: { ...state.status, fetch: 'failed' } };
    case TAGS_CREATE_FAILURE:
      return { ...state, loading: false, error: action.payload.error, status: { ...state.status, create: 'failed' } };
    case TAGS_DELETE_FAILURE:
      return { ...state, loading: false, error: action.payload.error, status: { ...state.status, delete: 'failed' } };
    case VENDOR_TAG_UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload.error, status: { ...state.status, update: 'failed' } };
    default:
      return state;
  }
}


